/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
require('components/common/search-tool/search-tool');
require('components/common/date-time/date-time')
require('components/base/input-box/input-box');
require('components/base/btn/btn');
require('components/base/loading/loading');

const store = require('appVuex/store');
const tip = require('components/base/pop/tip');
const { inputBox: inputBoxEvent} = require('components/config/event.json');
const confirm = require('components/base/pop/confirm');
const configPushMixin = require('../../mixin')
const ajaxHttp = require('appUtil/ajaxHttp.js')

const { apiPath } = require('appService/api');


require('./brand-manager-list.scss');
const template = require('./brand-manager-list.tpl');

const desktopPushList = {
  name: "brand-manager-list",

  template,

  data() {
    return {
      thItems: ["序号", "品牌名称", "品牌LOGO", "认证车主数", "排序", "可见性", "操作"],
      thItemSort:[
        {
          txt:'序号',
          isSort:0
        },
        {
          txt:'品牌名称',
          isSort:0
        },
        {
          txt:'品牌LOGO',
          isSort:0
        },
        {
          txt:'认证车主数',
          isSort:1,
          keys:'browse',
          sortVal:1
        },
        {
          txt:'排序',
          isSort:0
        },
        {
          txt:'可见性',
          isSort:0
        },
        {
          txt:'操作',
          isSort:0
        }
      ],
      tagBanner:{},
      url: apiPath.configPush.brandManager.list,
      changeUrl:apiPath.configPush.brandManager.changeStatus,
      placeItem:'输入品牌名称',
      queryOpt: {searchName:"brandName", searchVal:""},
      sortTypeVal:"",
      searchName:"brandName",
      searchVal:"",
      priorityVal:""
      
    }
  },
  mixins: [configPushMixin],

  methods: {
    searchData() {
      let _arg = {
        "searchName":this.searchName,
        "searchVal":this.searchVal
      }
      if(this.sortTypeVal !=""){
        Object.assign(_arg, {"sortType":this.sortTypeVal})
      }
      this.$refs.tableData.query(_arg).fetch()
    },

    brandShow(id,idx,val){ //隐藏
        let that = this;
        let _val = val==0? 1: 0;
        let args = {
          'id': id,
          'isVisible': _val
        };

        if(val==1){
          this.changeStatus(args,idx,_val);
          return;
        }

        confirm({
          message:'请确定该品牌社区的分类各话题已添加',
          cb(confirm) {
            confirm.hide();
            that.changeStatus(args,idx,_val);
          }
        })
       
      },

    changeStatus(args,idx,val){

        ajaxHttp(this.changeUrl, {
            type: "post",
            data: args
        }).then((res)=> {

            let _pro = typeof args.isVisible=='undefined'? "priority" : "visible";
            this.$refs.tableData.trItems[idx][_pro] = val;
            this.$refs.popspriority.hide();
            tip("修改成功");
        }).catch((res)=> {
            tip(res.message);
        })
    },
   sortTableCall(idx,stas){
    console.log(idx+'__'+stas);
      let _val = this.thItemSort[idx].sortVal;
      let _sortVal = stas==0? "" : stas==1? _val :(0-_val);
      this.sortTypeVal = _sortVal;
      this.searchData();

    },
    priorityFn(){
      let _val = this.$refs.priorityCont.value;

      if( _val=="" || !/^[1-9][0-9]*$/.test(_val)){
        tip("排序级别只能为正整数");
        return;
      }
       let args = {
          'id': this.tagBanner.id,
          'priority': _val
        };

      this.changeStatus(args,this.tagBanner.idx,_val);

    },
    changePriority(id, idx, val) {
      let _obj = {
        id:id,
        idx:idx,
        val:val
      };
      Object.assign(this.tagBanner,_obj);
      this.priorityVal = val;
      this.$refs.popspriority.show();
      
    }
  },
  events:{
    [inputBoxEvent.change](obj){
          this.searchVal = obj.value
    }
  },
}

module.exports = desktopPushList;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/brand-manager/brand-manager-list/brand-manager-list.js